export const selectToken = (state) => state.user.token;

export const selectUser = (state) => state.user;

export const selectUserFavourite = (state) => state.user.favourite;
